import React, { FC } from 'react';
import { useI18n } from '~Hooks';
import { Box } from '~Styles';
import Paragraph from '~ComponentsImproved/Typography/Paragraph';
import { ImpulseSpinner } from '~Components/ImpulseSpinner';

/** Shown while a charge or undo is in flight; no actions so it can't be sent twice. */
const SendingStep: FC = () => {
  const { i18n } = useI18n();

  return (
    <Box fluid display="flex" flexDirection="column" alignItems="center" gap="medium" padding="xl">
      <ImpulseSpinner size={48} />
      <Paragraph level={2} color="var(--colorBlueGray200)">
        {i18n('HotelRoom.Sending')}
      </Paragraph>
    </Box>
  );
};

export default SendingStep;
